export default __webpack_public_path__ + "static/media/logo.b0624e6e.png";